import React, { useCallback } from 'react';

import useOutsideClick from 'hooks/useOutsideClick';

import { Container, Items, Item } from './styles';

export interface OptionsItem {
  text: string;
  value: any;
}

interface Props {
  show: boolean;
  value: any;
  items: OptionsItem[];
  selectRef: React.RefObject<HTMLDivElement>;
  onChange: (value: any) => void;
  onClose: () => void;
}

const Options = ({ show, items, selectRef, value, onChange, onClose }: Props) => {
  useOutsideClick(selectRef, onClose);

  const isActive = useCallback((item: OptionsItem) => item.value === value, [value]);

  const handleItemClick = (item: OptionsItem) => {
    if (item.value !== value) {
      onChange(item.value);
    }
    onClose();
  };

  return show ? (
    <Container>
      <Items>
        {items.map((item) => (
          <Item key={item.value} className={isActive(item) ? 'active' : ''} onClick={() => handleItemClick(item)}>
            {item.text}
          </Item>
        ))}
      </Items>
    </Container>
  ) : null;
};

export default Options;
